import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { TrendingUp, ClipboardCheck, Mail } from "lucide-react";

const Stat = ({ label, v7, v30, suffix = "", testid }) => (
  <div className="rounded-2xl border border-border bg-card p-5" data-testid={testid}>
    <p className="text-sm font-medium mb-3">{label}</p>
    <div className="flex gap-6">
      <div><p className="text-2xl font-bold">{v7}{suffix}</p><p className="text-xs text-muted-foreground">last 7 days</p></div>
      <div><p className="text-2xl font-bold">{v30}{suffix}</p><p className="text-xs text-muted-foreground">last 30 days</p></div>
    </div>
  </div>
);

const AdminTrackingPage = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/admin/tracking/overview`).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="p-6 text-muted-foreground">Loading…</div>;
  return (
    <div data-testid="admin-tracking-page" className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold flex items-center gap-2"><TrendingUp className="w-6 h-6 text-primary" /> Tracking</h2>
        <p className="text-sm text-muted-foreground">Day-2 return and readiness-check funnel.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat label="Day-2 return rate" v7={d.day2_return.last_7.pct} v30={d.day2_return.last_30.pct} suffix="%" testid="stat-day2" />
        <Stat label="Readiness-check completions" v7={d.readiness_completions.last_7} v30={d.readiness_completions.last_30} testid="stat-readiness" />
        <Stat label="Emails captured (from the check)" v7={d.emails_captured.last_7} v30={d.emails_captured.last_30} testid="stat-emails" />
      </div>

      {(d.paywall_views || d.trial_unlocked) && (
        <div>
          <h3 className="text-lg font-semibold mb-3 mt-2">Freemium (value-moment paywalls)</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <Stat label="Paywall views" v7={d.paywall_views?.last_7?.total || 0} v30={d.paywall_views?.last_30?.total || 0} testid="stat-paywall-views" />
            <Stat label="Paywall clicks" v7={d.paywall_clicks?.last_7?.total || 0} v30={d.paywall_clicks?.last_30?.total || 0} testid="stat-paywall-clicks" />
            <Stat label="Trials unlocked" v7={d.trial_unlocked?.last_7?.total || 0} v30={d.trial_unlocked?.last_30?.total || 0} testid="stat-trials-unlocked" />
          </div>
          <div className="grid sm:grid-cols-2 gap-4 mt-4">
            <div className="rounded-2xl border border-border bg-card p-5" data-testid="paywall-by-wall">
              <p className="text-sm font-medium mb-3">Paywall views by wall (30d)</p>
              {["daily_cap", "lesson_lock", "results_fix", "mock_breakdown"].map((w) => (
                <div key={w} className="flex items-center justify-between text-sm py-1">
                  <span className="text-muted-foreground">{w}</span>
                  <span className="font-semibold">{d.paywall_views?.last_30?.[w] || 0} views · {d.paywall_clicks?.last_30?.[w] || 0} clicks</span>
                </div>
              ))}
            </div>
            <div className="rounded-2xl border border-border bg-card p-5" data-testid="trials-by-reason">
              <p className="text-sm font-medium mb-3">Trials unlocked by reason (30d)</p>
              {["readiness", "20_questions"].map((r) => (
                <div key={r} className="flex items-center justify-between text-sm py-1">
                  <span className="text-muted-foreground">{r}</span>
                  <span className="font-semibold">{d.trial_unlocked?.last_30?.[r] || 0}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      <p className="text-xs text-muted-foreground flex items-center gap-2">
        <ClipboardCheck className="w-3.5 h-3.5" /> Day-2 return = of users who signed up, the share active again the next day
        &nbsp;·&nbsp; <Mail className="w-3.5 h-3.5" /> Emails captured = accounts created that carried a readiness snapshot.
      </p>
    </div>
  );
};

export default AdminTrackingPage;
